import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        brand:
          "border-transparent bg-brand/10 text-brand hover:bg-brand/15",
        success:
          "border-transparent bg-success/10 text-success hover:bg-success/15",
        // INK OVER A TINT, so `text` and not `foreground`.
        // `--warning-foreground` is the ink for a SOLID amber fill; over
        // `bg-warning/15` on a near-black card it measured 1.06:1 — a
        // near-black label on a near-black ground, which is not a low
        // contrast so much as an invisible badge.
        warning:
          "border-transparent bg-warning/15 text-warning-text hover:bg-warning/20",
        // This variant was DEAD: `bg-info`/`text-info` named a colour that
        // did not exist in tailwind.config.js, so the classes generated
        // nothing and the badge rendered transparent with inherited text.
        // The tokens exist now, and the ink half is the one it points at.
        info:
          "border-transparent bg-info/10 text-info-text hover:bg-info/15",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
